import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        prospect: null
    },
    mutations: {
        SET_PROSPECT(state, data) {
            state.prospect = data;
        }
    },
    getters: {
        // Basic prospect info
        prospect(state) {
            return state.prospect;
        },
        accountName(state) {
            return state.prospect?.AccountName || '';
        },
        globalReference(state) {
            return state.prospect?.GlobalReference || '';
        },

        // Upcoming viewings
        upcomingViewings(state) {
            return state.prospect?.UpcomingViewings || [];
        },
        historicViewings(state) {
            return state.prospect?.ViewedProperties || [];
        },

        upcomingLettingsViewings(state) {
            return state.prospect?.UpcomingViewings?.flatMap(viewing => 
                viewing.LettingsProperties.map(property => ({
                    ...property,
                    viewingDate: viewing.ViewingDate,
                    viewingDateDisplay: viewing.ViewingDateDisplay,
                    viewingOID: viewing.OID
                }))
            ) || [];
        },

        // Viewed properties
        viewedProperties(state) {
            return state.prospect?.ViewedProperties || [];
        },
        hasViewedProperties(state) {
            return (state.prospect?.ViewedProperties.length || 0) > 0;
        },

        // Alert settings
        alertSettings(state) {
            return state.prospect?.AlertSettings || {
                Email: '',
                Mobile: '',
                SubscribedToPropertyAlerts: false
            };
        },
        isSubscribedToAlerts(state) {
            return state.prospect?.AlertSettings?.SubscribedToPropertyAlerts || false;
        },

        // Preferences
        preferences(state) {
            return state.prospect?.Preferences || {
                MinBeds: 0,
                MaxRent: 0,
                MoveIn: null,
                Furnished: 'Unfurnished',
                AllowShared: false
            };
        },
        moveInDate(state) {
            return state.prospect?.Preferences?.MoveIn || null;
        },
        formattedMoveInDate(state) {
            const date = state.prospect?.Preferences?.MoveIn;
            if (!date) return '';
            return new Date(date).toLocaleDateString();
        },
        minBedrooms(state) {
            return state.prospect?.Preferences?.MinBeds || 0;
        },
        maxRent(state) {
            return state.prospect?.Preferences?.MaxRent || 0;
        },
        prefersFurnished(state) {
            return state.prospect?.Preferences?.Furnished || 'Unfurnished';
        },
        allowsShared(state) {
            return state.prospect?.Preferences?.AllowShared || false;
        }
    },
    actions: {
        async getProspectTenant({ commit }, payload) {
            try {
                const params = {
                    body: {
                        clientName: payload.clientName,
                        prospectID: payload.prospectID
                    }
                };

                const response = await API_SERVICE.post(
                    "peoplePortalRestAPI", 
                    "/accounts/tenant/prospect",
                    params
                );

                if (response.status === "200") {
                    commit("SET_PROSPECT", response.data);
                    return {
                        success: true,
                        error: null
                    };
                }
                return {
                    success: false,
                    error: "Failed to fetch prospect data"
                };
            } catch (error) {
                console.error("Error fetching prospect tenant:", error);
                return {
                    success: false,
                    error: error.message
                };
            }
        }
    }
}